import { parseBoolVariable } from '@/helpers/envs';

const { VUE_APP_GA_MEASUREMENT_ID: GA_MEASUREMENT_ID, VUE_APP_GA_ENABLED: enabled } = process.env;

const ENABLED = parseBoolVariable(enabled);

export { GA_MEASUREMENT_ID, ENABLED };
